// utils

import { ALL_RECORDS_COUNT, apiConfig } from 'config';
import { IBoostGroup } from '../@types/boost';
import { WrapperService } from './wrapper';
import { IBoostGroupModel, BoostGroupLookUpTypes } from '../@types/boostGroup';
import { AxiosResponse } from 'axios';

export class BoostGroupService {
  public apiService: WrapperService = new WrapperService();

  /**
   * Get information of ONLY ONE boost group or sub boost group. The endpoint is the same.
   */

  getGroup(ownerId: string, boostGroupId: number): Promise<AxiosResponse> {
    const apiParam = {
      method: 'GET',
      url: `/owner/${ownerId}/boostGroup/${boostGroupId}`,
      baseURL: apiConfig.asset_mgt
    };
    return this.apiService.httpCall(apiParam);
  }

  updateBoostGroup(ownerId: string, boostGroupId: number, body) {
    const apiParam = {
      method: 'PATCH',
      url: `/owner/${ownerId}/boostGroup/${boostGroupId}/update`,
      baseURL: apiConfig.asset_mgt,
      body
    };
    return this.apiService.httpCall(apiParam);
  }

  /**
   * Update the boost group or sub boost group configuration.
   */
  updateBoostGroupConfiguration(
    ownerId: string,
    boostGroupId: number,
    body
  ): Promise<AxiosResponse> {
    const apiParam = {
      method: 'PATCH',
      url: `/owner/${ownerId}/boostGroup/${boostGroupId}/configuration/update`,
      baseURL: apiConfig.asset_mgt,
      body
    };
    return this.apiService.httpCall(apiParam);
  }
  /**
   * delete Hours.
   */
  deleteHours(ownerId: string, boostGroupId: number, hoursType: string): Promise<AxiosResponse> {
    const apiParam = {
      method: 'DELETE',
      url: `/owner/${ownerId}/boostGroup/${boostGroupId}/configuration/hours/${hoursType}/remove`,
      baseURL: apiConfig.asset_mgt
    };
    return this.apiService.httpCall(apiParam);
  }

  createBoostGroup(ownerId: string, body: IBoostGroupModel) {
    const apiParam = {
      method: 'POST',
      url: `/owner/${ownerId}/boostGroup/add`,
      baseURL: apiConfig.asset_mgt,
      body
    };
    return this.apiService.httpCall(apiParam);
  }

  /**
   * Get the list of all boost groups or sub boost groups.
   */
  getBoostGroups(params: {
    ownerId: string;
    boostGroupId?: number;
    isSubGroup?: boolean;
    currentPage?: number;
    size?: number;
    filterName?: string;
    sort?: string;
    order?: string;
  }): Promise<AxiosResponse> {
    const {
      ownerId,
      boostGroupId,
      isSubGroup,
      currentPage = 0,
      size = ALL_RECORDS_COUNT,
      filterName,
      order
    } = params;
    const apiParam = {
      method: 'GET',
      url: isSubGroup
        ? `/owner/${ownerId}/boostGroup/${boostGroupId}/subBoostGroups`
        : `/owner/${ownerId}/boostGroup/all`,
      baseURL: apiConfig.asset_mgt,
      params: {
        page: currentPage,
        size,
        searchInput: filterName,
        sort: order
      }
    };
    return this.apiService.httpCall(apiParam);
  }

  public submitSubBoostGroup(
    apiMethod: 'POST' | 'PUT' | 'PATCH',
    ownerId: unknown,
    subBoostGroup: IBoostGroup
  ) {
    let url: string;
    if (apiMethod === 'PUT' || apiMethod === 'PATCH') {
      url = `/owner/${ownerId}/boostGroup/${subBoostGroup.id}/update`;
    } else {
      url = `/owner/${ownerId}/boostGroup/${subBoostGroup.id}`;
    }
    const apiParam = {
      method: apiMethod,
      body: subBoostGroup,
      url: url,
      baseURL: apiConfig.asset_mgt
    };
    return this.apiService.httpCall(apiParam);
  }

  deleteBoostGroup(ownerId: string, boostGroupId: number) {
    const apiParam = {
      method: 'DELETE',
      url: `/owner/${ownerId}/boostGroup/${boostGroupId}/remove`,
      baseURL: apiConfig.asset_mgt
    };
    return this.apiService.httpCall(apiParam);
  }

  getGroupHierarchy() {
    const apiParam = {
      method: 'GET',
      url: `/boostGroup/hierarchy`,
      baseURL: apiConfig.asset_mgt
    };
    return this.apiService.httpCall(apiParam);
  }

  lookup(library: BoostGroupLookUpTypes) {
    const apiParam = {
      method: 'GET',
      url: `/lookup/${library}`,
      baseURL: apiConfig.asset_mgt
    };
    return this.apiService.httpCall(apiParam);
  }
}
